import { observer } from "mobx-react";
import * as React from "react";

import { ListSafetyMessages } from "../ui/molecules/list-safety-messages";
import { createUuid } from "../utils/uuid";
import { Section } from "../ui/atoms/section";
import { SelectionMode } from "@fluentui/react";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageSafetyMessages extends React.Component {
    // Create the UUID on this level, so the button bar is able to access the same state as the list.
    private listStateId = createUuid();

    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[articles.safetyMessageReport]}
                breadcrumb={store.i18n.t("page.safetyMessages.title")}
                classic
            >
                <Section fill>
                    <ListSafetyMessages
                        listStateId={this.listStateId}
                        selectionMode={SelectionMode.none}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
